module.exports = __webpack_public_path__ + "static/media/dat.bd47a407.jpg";